<template>
	<div>
		<page-title-bar></page-title-bar>
		<app-section-loader :status="loader"></app-section-loader>

        <v-snackbar :top="yes" v-model="snackbar">
			{{ snackbarMessage }}
		</v-snackbar>

	<v-container fluid grid-list-xl pt-0>
			<app-card>
				<v-btn color="default" @click="cancel" name="btncancel" >Terug</v-btn>
			</app-card>
            <app-card>
            
               <v-tabs icons-and-text  color="#fff">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-basic">
                        Basis info
                        <v-icon>face</v-icon>
                    </v-tab>
                    <div v-show="isNew === false">
                         <v-tab href="#tab-onlineres">
                            Online behandelingen
                            <v-icon>calendar_today</v-icon>
                        </v-tab>

                        <v-tab href="#tab-hours">
                            Uurrooster 
                            <v-icon>calendar_today</v-icon>
                        </v-tab>
                    </div>
                    <!-- BASIS INFO BLOK -->
                    <v-tab-item :id="'tab-basic'">
                    <v-card flat>
                    <v-card-text>
                        <v-flex xs12 sm6>

                                 <v-flex xs12 sm6>
                                    <v-text-field  label="Naam"  v-model="record.UserName"></v-text-field>
                                   
                                    </v-flex>
                                </v-flex>

                        </v-flex>
                        <v-flex xs12 sm6 lg6>
                                 <v-flex xs12 sm3>
                                    <v-checkbox  label="Is aktief"  v-model="record.IsActive"></v-checkbox> 
                                    <v-checkbox  label="Verberg in agenda"  v-model="record.IsHideScheduler"></v-checkbox> 
                                </v-flex>
                        </v-flex>

                    </v-card-text>
                    </v-card>
                    </v-tab-item>
                    <!-- AFSPRAKEN INFO BLOK -->
                    <v-tab-item :id="'tab-hours'">
                    <v-card flat>
                    <v-card-text>
                       <user-hours-tab :record="this.record" ></user-hours-tab>
                    </v-card-text>
                    </v-card>
                    </v-tab-item>

                    <!-- AFSPRAKEN INFO BLOK -->
                    <v-tab-item :id="'tab-onlineres'">
                    <v-card flat>
                    <v-card-text>
                        <user-online-serv-tab :record="this.record" ref="instOnlineRes"></user-online-serv-tab>
                    </v-card-text>
                    </v-card>
                    </v-tab-item>
                </v-tabs>
                
			</app-card>
		</v-container>
	</div>
</template>
<script>
import Vue from 'vue';
import UserHoursTab from "Components/User/UserHoursTab";
import UserOnlineServTab from "Components/User/UserOnlineServTab";

import myHttpApi from "../../api/myHttpApi";
import router from '../../router';

export default {
   props: {
       id : String,
       kindrec : Number,
       isNew : Boolean
    },
  data() {
    return {
        loader: true,
        disable: false,
        record: {},
        itemsKind : {},
        imgPicBase : '',
        hasImage: false,
        image: null,
        snackbar: false,
		snackbarMessage: "",
    };
  },
   components: {
     UserHoursTab,
     UserOnlineServTab
  },
  mounted() {
    this.imgPicBase = Vue.$urlImgNoPic;
    this.loader = false;
    this.itemsKind = [
        {"descr":"Medewerker", "id":1},
        {"descr":"Ruimte / toestel", "id":100},
    ]
    this.getTableData()
  },
  methods: {
    cancel ()  {
        router.go (-1);
    },
    save () {

        myHttpApi.post('BOUser/Save', this.record)
        .then(response => {
            this.loader = false;

            if (response.data.ResultCode != 200)
            {
                alert (response.data.ResultMessage);
            }
            else
            {
                if (this.$refs.instOnlineRes.isChanged)
                {
                     myHttpApi.post('BOUser/SaveOnlineServices', this.$refs.instOnlineRes.onlineUsrData)
                    .then(response => {
                        this.disable = true;
                    })
                    .catch(error => {
                        console.log(error);
                        alert (error);
                    });
                }
                else
                {
                    this.disable = true;
                }
            }

            
        })
        .catch(error => {
            console.log(error);
        });
    },
    getTableData() {
      myHttpApi
		const searchRec = {Search: this.id, Extra: ""}
		myHttpApi.post('BOUser/Get', searchRec)
        .then(response => {
          this.loader = false;
          this.record = response.data;
          if (this.isNew) {this.record.KindUser = 1;}  
          if (this.record.ExceptHours == null) {this.record.ExceptHours = [];}
          if (this.record.UserHours == null) {this.record.UserHours = [];}

        })
        .catch(error => {
          console.log(error);
        });
    },
  }
};
</script>
